import request from '@/utils/request'

export const listPaymentDiscountPolicies = (params) =>
  request({ url: '/api/payment-discount-policies', method: 'get', params })

export const createPaymentDiscountPolicy = (data) =>
  request({ url: '/api/payment-discount-policies', method: 'post', data })

export const updatePaymentDiscountPolicy = (policyId, data) =>
  request({ url: `/api/payment-discount-policies/${policyId}`, method: 'put', data })

export const confirmPaymentDiscountPolicy = (policyId) =>
  request({ url: `/api/payment-discount-policies/${policyId}/confirm`, method: 'post' })

export const resolvePaymentDiscountPolicy = (data) =>
  request({ url: '/api/payment-discount-policies/resolve', method: 'post', data })
